import React from 'react';

export const CloseCircleGradient = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3334 9.99999C18.3334 14.6025 14.6026 18.3333 10.0001 18.3333C5.39758 18.3333 1.66675 14.6025 1.66675 9.99999C1.66675 5.39749 5.39758 1.66666 10.0001 1.66666C14.6026 1.66666 18.3334 5.39749 18.3334 9.99999ZM7.47508 7.47499C7.59227 7.35795 7.75112 7.29221 7.91675 7.29221C8.08237 7.29221 8.24123 7.35795 8.35841 7.47499L10.0001 9.11666L11.6417 7.47499C11.7602 7.36459 11.9169 7.30449 12.0789 7.30734C12.2408 7.3102 12.3953 7.37579 12.5098 7.49031C12.6243 7.60482 12.6899 7.7593 12.6927 7.92122C12.6956 8.08314 12.6355 8.23984 12.5251 8.35832L10.8834 9.99999L12.5251 11.6417C12.6355 11.7601 12.6956 11.9168 12.6927 12.0788C12.6899 12.2407 12.6243 12.3952 12.5098 12.5097C12.3953 12.6242 12.2408 12.6898 12.0789 12.6926C11.9169 12.6955 11.7602 12.6354 11.6417 12.525L10.0001 10.8833L8.35841 12.525C8.23994 12.6354 8.08323 12.6955 7.92131 12.6926C7.7594 12.6898 7.60491 12.6242 7.4904 12.5097C7.37589 12.3952 7.31029 12.2407 7.30744 12.0788C7.30458 11.9168 7.36468 11.7601 7.47508 11.6417L9.11675 9.99999L7.47508 8.35832C7.35804 8.24114 7.2923 8.08228 7.2923 7.91666C7.2923 7.75103 7.35804 7.59218 7.47508 7.47499Z"
      fill="url(#paint0_linear_3340_2133)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3340_2133"
        x1="1.66675"
        y1="9.99999"
        x2="18.3334"
        y2="9.99999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B73A3D" />
        <stop offset="1" stopColor="#E96D70" />
      </linearGradient>
    </defs>
  </svg>
);
